import { useFieldProgramStats } from '@cibo/landmanager'
import { useOrganizationContent } from '@cibo/profile'
import { useProgram, useProgramStats, useWorkflows } from '@cibo/programs'
import { ClickableCard } from '@cibo/ui'
import { FC } from 'react'
import { ProgramOpportunityDisplay } from './ProgramOpportunityDisplay'
import { ProgramOpportunityProps } from './ProgramOpportunityTypes'

export const ProgramOpportunity: FC<ProgramOpportunityProps> = ({
  children,
  programId,
  hideBanner,
  hideOpportunities,
  userId,
  orgId,
  tokens,
  ...cardProps
}) => {
  const program = useProgram({ programId, owner: userId, orgId })
  const workflows = useWorkflows(0, 1, {
    programId,
    benchmark: ['enrollment'],
    filters: !!userId ? { userId: [userId] } : undefined,
  })
  const stats = useProgramStats({ userId, orgId })
  const fieldStats = useFieldProgramStats({ programId, userId, options: { refetchOnMount: true } })

  const organization = useOrganizationContent({
    contentfulOrgId: program.data?.sponsorOrg?.contentfulOrgId,
  })

  return (
    <ClickableCard {...cardProps}>
      <ProgramOpportunityDisplay
        hideBanner={hideBanner}
        program={program.data}
        isLoading={
          program.isLoading || stats.isLoading || workflows.isLoading || organization.isLoading
        }
        isError={program.isError || stats.isError || workflows.isError}
        enrollmentCount={workflows.data?.numAvailable || 0}
        opportunities={!hideOpportunities && !!fieldStats.data ? fieldStats.data : undefined}
        orgContent={organization.data}
        stat={stats.data?.programs?.find(p => p.programId === programId)}
        tokens={!!tokens ? tokens : program.data?.rewardTokens}
        userId={userId}
      />
      {children}
    </ClickableCard>
  )
}
